/** @jsx jsx */
import React, { memo } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { useSidebar } from '@atlassian/jira-business-app-wrapper/src/controllers/sidebar/index.tsx';
import { getColorMetadata } from '../color-picker/utils/index.tsx';

export type ColorIndicatorProps = {
	color: string | null | undefined;
	canModifyOptions: boolean;
	fieldType: string;
};

export const ColorIndicator = memo(
	({ canModifyOptions, fieldType, color }: ColorIndicatorProps) => {
		const { backgroundColor, messageLabel } = getColorMetadata(color);
		const { formatMessage } = useIntl();
		const [{ content: sidebarContent }] = useSidebar();

		if (
			sidebarContent ||
			!canModifyOptions ||
			fieldType !== 'com.atlassian.jira.plugin.system.customfieldtypes:select'
		)
			return null;
		return (
			<Tooltip content={formatMessage(messageLabel)}>
				<div
					css={styledColorBox}
					// eslint-disable-next-line jira/react/no-style-attribute
					style={{ borderColor: backgroundColor }}
				/>
			</Tooltip>
		);
	},
);

const styledColorBox = css({
	width: token('space.200'),
	height: token('space.200'),
	borderRadius: token('border.radius.100'),
	borderWidth: token('border.width.outline'),
	borderStyle: 'solid',
});
